var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.maximized)?_c('div',{attrs:{"id":"switcher"},on:{"click":function($event){return _vm.toggleMapillary()}}},[_c('b-icon-arrows-fullscreen',{attrs:{"id":"icon","scale":"1.2","aria-hidden":"true"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }